<script>
import { Icon } from 'svelte-icons-pack';
import { BiTrendingUp } from "svelte-icons-pack/bi";
export let lines;
</script>

<h6>
  <Icon src={BiTrendingUp} size="20" color="CornflowerBlue"/>
  Trade Count
</h6>

<div style="font-size: 20px; display: inline; color: red;">{lines['sell']} 
  <p style="font-size: large; display: inline; margin: 0;">Sells</p>
</div>
<br>
<div style="font-size: 20px; display: inline; color: green;">{lines['buy']} 
  <p style="font-size: large; display: inline; margin: 0;">Buys</p>
</div>

  


